/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Failed_ParqInputs */

const en_us2_onboarding_failed_parq = /** @type {(inputs: Onboarding_Failed_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped while saving the health questions.`)
};

const pt_br2_onboarding_failed_parq = /** @type {(inputs: Onboarding_Failed_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao salvar as perguntas de saúde.`)
};

const es_419_onboarding_failed_parq = /** @type {(inputs: Onboarding_Failed_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se detuvo al guardar las preguntas de salud.`)
};

const pt_pt2_onboarding_failed_parq = /** @type {(inputs: Onboarding_Failed_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parou ao guardar as perguntas de saúde.`)
};

const fr_fr2_onboarding_failed_parq = /** @type {(inputs: Onboarding_Failed_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrompu pendant l'enregistrement des questions de santé.`)
};

const de_de2_onboarding_failed_parq = /** @type {(inputs: Onboarding_Failed_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Speichern der Gesundheitsfragen ist es hängen geblieben.`)
};

const it_it2_onboarding_failed_parq = /** @type {(inputs: Onboarding_Failed_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è interrotto mentre salvava le domande sulla salute.`)
};

/**
* | output |
* | --- |
* | "It stopped while saving the health questions." |
*
* @param {Onboarding_Failed_ParqInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_failed_parq = /** @type {((inputs?: Onboarding_Failed_ParqInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Failed_ParqInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_failed_parq(inputs)
	if (locale === "es-419") return es_419_onboarding_failed_parq(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_failed_parq(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_failed_parq(inputs)
	if (locale === "de-DE") return de_de2_onboarding_failed_parq(inputs)
	if (locale === "it-IT") return it_it2_onboarding_failed_parq(inputs)
	return en_us2_onboarding_failed_parq(inputs)
});
export { onboarding_failed_parq as "onboarding.failed_parq" }